var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPurplePinIcon = function SvgPurplePinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8424FF",
    d: "M7.4.3C7-.1 6.4-.1 6 .3L3.9 2.4l-1.933.067c-.134.033-.234.133-.234.266 0 .067.034.134.067.167L2.9 4 .533 7.6a.258.258 0 0 0 .067.333c.1.067.2.067.267 0L4.5 5.6l1.1 1.1c.1.1.267.1.367 0a.255.255 0 0 0 .066-.167l.067-1.9 1.7-1.7a.26.26 0 0 0 .133-.133l.267-.267c.4-.4.4-1 0-1.4L7.4.3ZM5.867 4.167l-1.5-1.5 1.466-1.5 1.5 1.5-1.466 1.5Zm-4.234 2.7 1.634-2.5.833.833-2.467 1.667Zm3.9-.934c-1-.966-2.066-2.066-2.966-2.966L3.9 2.9l1.7 1.7-.067 1.333Zm2.334-3.8-.167.2L6.167.8l.166-.167c.2-.2.5-.2.7 0l.8.8c.2.2.2.534.034.7Z"
  })));
};
export default SvgPurplePinIcon;